import React, { useState, useEffect } from "react";
import { ENV } from "../../config/config";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { useGetCategoriesQuery, useGetCategoryQuery, useCreateCategoryMutation, useUpdateCategoryMutation, useDeleteCategoryMutation, useGetCategoriesSelectQuery } from "../../redux/api";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import localeInfo from "rc-pagination/lib/locale/en_US";
import {
  Button,
  Card,
  Form,
  Table,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useGetGalleryQuery, useGetRoleQuery } from "../../redux/api";
import CategoryModal from "./categoryModal";
import validator from "validator";
import Select from "react-select";
import GalleryModal from "components/Gallery/galleryModal";
import { useSelector } from "react-redux";
const { objectToQueryString, decimalNumberValidator } = ENV;
var CryptoJS = require("crypto-js");

const Categories = () => {
  const initialImage = {
    search: null,
    related: null,
    default: null,
  };
  const initialCategory = {
    name: "",
    url: "",
    parentId: null,
    images: initialImage,
    color: "#0093b1",
    sortOrder: "",
    isExternal: false,
    isShowInTopMenu: false,
    isShowInFooter: false,
    isShowInHeader: false,
    isActive: true,
    metaTitle: "",
    metaKeyword: "",
    metaDescription: "",
  };
  const initialErrors = {
    name: "",
    url: "",
    parentId: "",
    sortOrder: "",
    image: "",
  };
  const initialFilters = {
    name: "",
    isExternal: "",
    isShowInTopMenu: "",
    isShowInFooter: "",
    isShowInHeader: "",
    isActive: "",
  };
  const [qs, setQs] = useState("");
  const [selectedImageType, setSelectedImageType] = useState("default");
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(initialCategory);
  const [id, setId] = useState("");
  const [categoryErrors, setCategoryErrors] = useState(initialErrors);
  const [pagination, setPagination] = useState(null);
  const [resetButton, setResetButton] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [filters, setFilters] = useState(initialFilters);
  const [modalType, setModalType] = useState(0); // 1 = view, 2 = add, 3 = edit
  const [openModal, setOpenModal] = useState(false);
  const [selectCategories, setSelectCategories] = useState([]);

  const { data: listCategoriesRes, isLoading: isCategoriesLoading, isFetching: isCategoriesFetching, refetch } = useGetCategoriesQuery(qs);
  const [createCategoryMut, { isLoading: isCreatingCategory }] = useCreateCategoryMutation();
  const [updateCategoryMut, { isLoading: isUpdatingCategory }] = useUpdateCategoryMutation();
  const [deleteCategoryMut, { isLoading: isDeletingCategory }] = useDeleteCategoryMutation();
  const { data: selectCategoriesRes, refetch: refetchSelect } = useGetCategoriesSelectQuery();

  // Gallery Model
  const [gallery, setGallery] = useState([]);
  const [isGalleryOpenModal, setGalleryOpenModal] = useState(false);
  const [galleryPagination, setGalleryPagination] = useState(null);
  const [galleryFilters, setGalleryFilters] = useState({
    name: "",
  });

  const [imageView, setImageView] = useState(initialImage);

  const [galleryResetButton, setGalleryResetButton] = useState(false);
  const gallerySelector = useSelector((state) => state.gallery);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const roleEncrypted = localStorage.getItem("role");
  const roleDecrypted = roleEncrypted
    ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
        CryptoJS.enc.Utf8
      )
    : "";
  const { data: roleData } = useGetRoleQuery(roleDecrypted, { skip: !roleEncrypted });
  useEffect(() => {
    if (roleData && roleData.role?.permissions) {
      if (typeof roleData.role.permissions === 'string') {
        setPermissions(JSON.parse(roleData.role.permissions));
      } else {
        setPermissions(roleData.role.permissions);
      }
    }
  }, [roleData]);
  useEffect(() => {
    if (listCategoriesRes) {
      setCategories(listCategoriesRes.categories);
      setPagination(listCategoriesRes.pagination);
    }
  }, [listCategoriesRes]);

  const { data: getCategoryRes, isLoading: isCategoryLoading } = useGetCategoryQuery(id, { skip: !id });
  useEffect(() => {
    if (getCategoryRes) {
      const { EntityImages, ...categoryRes } = getCategoryRes;
      const images = {};
      const ImageView = {};
      if (EntityImages && EntityImages.forEach) {
        EntityImages.forEach((item) => {
          images[item.page] = item.imageId;
          ImageView[item.page] = item.Gallery.image;
        });
      }
      const newCategoryRes = { ...categoryRes, images };
      setImageView(ImageView);
      setCategory(newCategoryRes);
    }
  }, [getCategoryRes, openModal]);

  useEffect(() => {
    if (selectCategoriesRes) {
      const normalized = Array.isArray(selectCategoriesRes)
        ? selectCategoriesRes
        : selectCategoriesRes?.data || selectCategoriesRes?.categories || [];
      setSelectCategories(normalized);
    }
  }, [selectCategoriesRes]);

  useEffect(() => {}, []);

  const [galleryQs, setGalleryQs] = useState("");
  const { data: galleryRes, isLoading: isGalleryLoading } = useGetGalleryQuery(galleryQs);
  const isGlobalLoading = isCategoriesLoading || isCategoriesFetching || isCategoryLoading || isGalleryLoading || isCreatingCategory || isUpdatingCategory || isDeletingCategory;
  useEffect(() => {
    if (galleryRes && galleryRes.gallery) {
      setGallery(galleryRes.gallery);
      setGalleryPagination(galleryRes.pagination);
    }
  }, [galleryRes]);

  const onPageChange = async (page) => {
    const nextQs = objectToQueryString({ page, ...filters });
    setQs(nextQs);
  };

  const applyFilters = () => {
    if (
      filters &&
      (filters.name ||
        filters.isActive ||
        filters.isShowInFooter ||
        filters.isShowInHeader ||
        filters.isExternal ||
        filters.isShowInTopMenu ||
        filters.categoryId)
    ) {
      setResetButton(true);
      const nextQs = objectToQueryString({ page: 1, limit: 10, ...filters });
      setQs(nextQs);
    } else {
      toast.error("Search fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  const deleteHandler = (catId) => {
    Swal.fire({
      title: "Are you sure you want to delete?",
      html: "If you delete an item, it will lost permanently.",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.value) {
        deleteCategoryMut(catId).then(() => {
          refetch();
        });
      }
    });
  };

  const reset = () => {
    setResetButton(false);
    setFilters(initialFilters);
    setQs("");
  };

  const resetModalContent = () => {
    setCategory(initialCategory);
    setImageView(initialImage);
    setSelectedImageType("default");
    setCategoryErrors(initialErrors);
  };
  const modalCloseHandler = () => {
    setOpenModal(!openModal);
    setModalType(0);
    setId("");
    resetModalContent();
  };

  const VALIDATION_ERROR_MESSAGES = {
    name: "Name field is Required.",
    url: "Url field is Required.",
    parentId: "Please select a parent category",
    sortOrder: "Sort Order field is Required.",
    image: "Image is Required.",
  };

  const validateField = (value, validator, errorMessage, field) => {
    if (validator(value)) {
      setCategoryErrors((prevErrors) => ({
        ...prevErrors,
        [field]: errorMessage,
      }));
      return false;
    } else {
      setCategoryErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
      return true;
    }
  };

  const submit = () => {
    let isValid = true;
    isValid &= validateField(
      category.name,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.name,
      "name"
    );
    isValid &= validateField(
      category.url,
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.url,
      "url"
    );
    isValid &= validateField(
      String(category.parentId),
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.parentId,
      "parentId"
    );
    isValid &= validateField(
      String(category.sortOrder),
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.sortOrder,
      "sortOrder"
    );
    isValid &= validateField(
      String(category.images.default ?? ""),
      validator.isEmpty,
      VALIDATION_ERROR_MESSAGES.image,
      "image"
    );
    isValid &=
      category.parentId === "-"
        ? (setCategoryErrors((prevErrors) => ({
            ...prevErrors,
            parentId: VALIDATION_ERROR_MESSAGES.parentId,
          })),
          false)
        : true;

    if (isValid) {
      const { Gallery, ...newCategory } = category;
      
      if (newCategory.parentId === "0" || newCategory.parentId === 0) {
        newCategory.parentId = null;
      }

      if (modalType === 2) {
        createCategoryMut(newCategory).then(() => {
          refetch();
          modalCloseHandler();
        });
      } else {
        updateCategoryMut(newCategory).then(() => {
          refetch();
          modalCloseHandler();
        });
      }
    }
  };

  const isAddViewEdit = (catId, mType) => {
    refetchSelect();
    resetModalContent();
    setModalType(mType);
    setOpenModal(true);
    if (mType == 2) {
      // selection handled by hook
    } else {
      setId(catId);
    }
  };

  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
  ];

  // Gallery Functions
  const fetchGallery = () => {
    setGalleryQs("");
    setGalleryOpenModal(true);
  };

  const setImage = (img) => {
    setCategory((prevCategory) => {
      const { Gallery, ...rest } = prevCategory;

      // Update the image for the selected type
      const updatedImages = {
        ...prevCategory.images, // Keep existing images
        [selectedImageType]: img.id, // Update the selected type
      };

      return { ...rest, images: updatedImages };
    });

    setImageView((prevViews) => ({
      ...prevViews,
      [selectedImageType]: img.image, // Update the preview for the selected type
    }));

    setCategoryErrors((prevErrors) => ({ ...prevErrors, image: "" }));
  };

  const onGalleryPageChange = async (page) => {
    const qs = objectToQueryString({ page, ...galleryFilters });
    setGalleryQs(qs);
  };

  const galleryReset = () => {
    setGalleryResetButton(false);
    setGalleryFilters({ name: "" });
    setGalleryQs("");
  };

  const applyGalleryFilters = () => {
    if (galleryFilters && galleryFilters.name) {
      setGalleryResetButton(true);
      const qs = objectToQueryString({ page: 1, limit: 10, ...galleryFilters });
      setGalleryQs(qs);
    } else {
      toast.error("Search fields are empty.", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  if (isGlobalLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
        <Container fluid>
          <Row className="pb-3">
            <Col sm={12}>
              <Card className="filter-card">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Filters</Card.Title>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xl={4} sm={6}>
                      <Form.Group>
                        <label>Search with name...</label>
                        <Form.Control
                          value={filters.name}
                          type="text"
                          placeholder="Search with name..."
                          onChange={(e) =>
                            setFilters({ ...filters, name: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6}>
                      <Form.Group>
                        <label>
                          Search with parent category...
                        </label>
                        <Form.Control
                          // className={msg.categoryId ? `on-error` : ``}
                          as="select"
                          onChange={(e) => {
                            setFilters({
                              ...filters,
                              categoryId: e.target.value,
                            });
                            // setMsg(prevErrors => ({ ...prevErrors, categoryId: '' }));
                          }}
                          value={filters?.categoryId}
                          placeholder="Select parent category"
                          required
                        >
                          <option value="-">Select category</option>
                          <option value="0">Parent</option>
                          {selectCategories &&
                            selectCategories.map((option, index) => (
                              <option key={index} value={option.id}>
                                {option.name}
                              </option>
                            ))}
                        </Form.Control>
                        {/* <span className={msg.categoryId !== '' ? `` : `d-none`}>
                                                        <label className="pl-1 text-danger">{msg.categoryId}</label>
                                                    </span> */}
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with external url...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Search categories with external url..."
                          name="status"
                          options={statusOptions}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              isExternal: e ? e.value : "",
                            })
                          }
                          value={statusOptions.filter(
                            (l) => l.value === filters.isExternal
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with topmenu...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Search with topmenu categories..."
                          name="status"
                          options={statusOptions}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              isShowInTopMenu: e ? e.value : "",
                            })
                          }
                          value={statusOptions.filter(
                            (l) => l.value === filters.isShowInTopMenu
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with header...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Search with header categories..."
                          name="status"
                          options={statusOptions}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              isShowInHeader: e ? e.value : "",
                            })
                          }
                          value={statusOptions.filter(
                            (l) => l.value === filters.isShowInHeader
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with footer...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Search with footer categories..."
                          name="status"
                          options={statusOptions}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              isShowInFooter: e ? e.value : "",
                            })
                          }
                          value={statusOptions.filter(
                            (l) => l.value === filters.isShowInFooter
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with status...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Search with categories status..."
                          name="status"
                          options={statusOptions}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              isActive: e ? e.value : "",
                            })
                          }
                          value={statusOptions.filter(
                            (l) => l.value === filters.isActive
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>

                    <Col xl={4} md={6}>
                      <Form.Group>
                        <Form.Label className="d-block mb-2">&nbsp;</Form.Label>
                        <div className="d-flex  filter-btns-holder">
                          <Button
                            className="btn-filled mr-3"
                            onClick={applyFilters}
                          >
                            Search
                          </Button>
                          {resetButton && (
                            <Button
                              variant="warning"
                              className="outline-button"
                              onClick={reset}
                            >
                              Reset
                            </Button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <Card className="table-big-boy">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Categories</Card.Title>
                    {permissions && permissions?.addCategory && (
                      <Button
                        className="float-sm-right btn-filled d-flex align-items-center"
                        onClick={() => {
                          isAddViewEdit(null, 2);
                        }}
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>
                        Add Category
                      </Button>
                    )}
                  </div>
                </Card.Header>
                <Card.Body className="table-full-width">
                  <div className="table-responsive">
                    <Table className="table-bigboy">
                      <thead>
                        <tr>
                          <th className="text-center td-start">#</th>
                          <th className="td-type">Name</th>
                          <th className="td-type">Parent Category</th>
                          <th className="td-type">External Url</th>
                          <th className="td-type">Show In Top Menu</th>
                          <th className="td-type">Show In Header</th>
                          <th className="td-type">Show In Footer</th>
                          <th className="td-type">Status</th>
                          <th className="td-actions text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {categories && categories.length ? (
                          categories.map((category, index) => {
                            return (
                              <tr key={index}>
                                <td className="text-center serial-col">
                                  {pagination &&
                                    pagination.limit * pagination.page -
                                      pagination.limit +
                                      index +
                                      1}
                                </td>
                                <td className="td-type">{category.name}</td>
                                <td className="td-type">
                                  {category?.parent?.name
                                    ? category?.parent?.name
                                    : "Parent"}
                                </td>
                                <td className="td-type">
                                  {" "}
                                  {category.isExternal ? (
                                    <span className="label label-success m-0">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="label label-danger m-0">
                                      Inactive
                                    </span>
                                  )}{" "}
                                </td>{" "}
                                <td className="td-type">
                                  {" "}
                                  {category.isShowInTopMenu ? (
                                    <span className="label label-success m-0">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="label label-danger m-0">
                                      Inactive
                                    </span>
                                  )}{" "}
                                </td>
                                <td className="td-type">
                                  {" "}
                                  {category.isShowInHeader ? (
                                    <span className="label label-success m-0">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="label label-danger m-0">
                                      Inactive
                                    </span>
                                  )}{" "}
                                </td>
                                <td className="td-type">
                                  {" "}
                                  {category.isShowInFooter ? (
                                    <span className="label label-success m-0">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="label label-danger m-0">
                                      Inactive
                                    </span>
                                  )}{" "}
                                </td>
                                <td className="td-type">
                                  {" "}
                                  {category.isActive ? (
                                    <span className="label label-success m-0">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="label label-danger m-0">
                                      Inactive
                                    </span>
                                  )}{" "}
                                </td>
                                <td className="td-actions text-center">
                                  <ul className="list-unstyled mb-0">
                                    {permissions &&
                                      permissions.viewCategory && (
                                        <li className="d-inline-block align-top">
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-436082023">
                                                {" "}
                                                View{" "}
                                              </Tooltip>
                                            }
                                            placement="left"
                                          >
                                            <Button
                                              className="btn-link btn-icon"
                                              type="button"
                                              variant="primary"
                                              // onClick={() => {
                                              //     isAddViewEdit(category.id, 1)
                                              // }}
                                              onClick={() => {
                                                if (category.isExternal)
                                                  window.open(
                                                    `${category.url}`,
                                                    "_blank"
                                                  );
                                                else
                                                  window.open(
                                                    `${ENV.frontendUrl}${category.url}`,
                                                    "_blank"
                                                  );
                                              }}
                                            >
                                              <FaEye />
                                            </Button>
                                          </OverlayTrigger>
                                        </li>
                                      )}
                                    {permissions &&
                                      permissions.editCategory && (
                                        <li className="d-inline-block align-top">
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-436082023">
                                                {" "}
                                                Edit{" "}
                                              </Tooltip>
                                            }
                                            placement="left"
                                          >
                                            <Button
                                              className="btn-link btn-icon"
                                              type="button"
                                              variant="success"
                                              onClick={() => {
                                                isAddViewEdit(category.id, 3);
                                              }}
                                            >
                                              <FaEdit />
                                            </Button>
                                          </OverlayTrigger>
                                        </li>
                                      )}
                                    {permissions &&
                                      permissions.deleteCategory && (
                                        <li className="d-inline-block align-top">
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-436082023">
                                                Delete
                                              </Tooltip>
                                            }
                                            placement="left"
                                          >
                                            <button
                                              type="button"
                                              className="btn-link btn-icon btn btn-danger"
                                              onClick={() => {
                                                deleteHandler(category.id);
                                              }}
                                            >
                                              <FaTrash />
                                            </button>
                                          </OverlayTrigger>
                                        </li>
                                      )}
                                  </ul>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="13" className="text-center">
                              <div className="alert alert-info" role="alert">
                                No Category Found
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {pagination && (
                      <Pagination
                        className="m-3"
                        defaultCurrent={1}
                        pageSize // items per page
                        current={pagination.page} // current active page
                        total={pagination.pages} // total pages
                        onChange={onPageChange}
                        locale={localeInfo}
                      />
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <CategoryModal
            modalType={modalType}
            setModalType={setModalType}
            selectCategories={selectCategories}
            modalCloseHandler={modalCloseHandler}
            openModal={openModal}
            setOpenModal={setOpenModal}
            category={category}
            setCategory={setCategory}
            submit={submit}
            categoryErrors={categoryErrors}
            setCategoryErrors={setCategoryErrors}
            fetchGallery={fetchGallery}
            imageView={imageView}
            setSelectedImageType={setSelectedImageType}
            selectedImageType={selectedImageType}
          />
          <GalleryModal
            isOpenModal={isGalleryOpenModal}
            setOpenModal={setGalleryOpenModal}
            setImage={setImage}
            gallery={gallery}
            pagination={galleryPagination}
            onPageChange={onGalleryPageChange}
            reset={galleryReset}
            applyFilters={applyGalleryFilters}
            filters={galleryFilters}
            setFilters={setGalleryFilters}
            resetButton={galleryResetButton}
          />
        </Container>
    </>
  );
};

export default Categories;
